module.exports = __webpack_public_path__ + "static/media/ideals_logo.2846a592.png";